<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter">
<img alt="Spooky illustration" class="ig" id="id-4313687163912302286" src="Images/img0001.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?04caba2b